
import { defineComponent } from 'vue';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'FactoryShow',
  components: {
    LeftOutlined,
    RightOutlined
  },
  data() {
    return {
      baseUrl,
      currentSlide: 1
    };
  },
  props: {
    factories: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    getStyle(i: number) {
      const index = i + 1;
      if (this.currentSlide > 4) {
        // const reminder = this.currentSlide % 4;

        const sIndex = this.currentSlide - 3;
        if (index >= sIndex && index <= this.currentSlide) {
          return { display: 'block' };
        }
        return { display: 'none' };

        // if (reminder === 0) {
        //   const factor = this.currentSlide / 4;
        //   const sIndex = (factor - 1) * 4 + 1;
        //   if (index >= sIndex && index <= this.currentSlide) {
        //     return { display: 'block' };
        //   }
        //   return { display: 'none' };
        // } else if (
        //   (this.currentSlide % 4) - index < 0 &&
        //   this.currentSlide - index >= 0
        // ) {
        //   return { display: 'block' };
        // }
        // return { display: 'none' };
      } else {
        if (index > 4) {
          return { display: 'none' };
        }

        return { display: 'block' };
      }
    },
    getImgUrl(i: number) {
      return baseUrl + (this.factories[i] as any).newsImageUrl;
    },
    handleAfterChange(current: number) {
      this.currentSlide = current + 1;
    }
  }
});
